import { useEffect, useState } from 'react';

/**
 * A ticking clock for elapsed-time displays. Kitchen tickets show how long an
 * order has been waiting, which has to keep counting even when no data changes.
 */
export function useNow(intervalMs = 1_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(timer);
  }, [intervalMs]);
  return now;
}
